module.exports = __webpack_public_path__ + "img/day02.b92a70d4.png";